export enum UserOrderListActionType {
  FETCH_USER_ORDER_LIST = "fetch_user_order_list",
  FETCH_USER_ORDER_LIST_SUCCESS = "fetch_user_order_list_success",
  FETCH_USER_ORDER_LIST_FAILURE = "fetch_user_order_list_failure",
}
